/* eslint-disable @typescript-eslint/indent */
import React, { useState } from 'react';
import { Checkbox, Radio, Typography } from '@pwskills/rachnaui';
// import { ChevronUp, ChevronDown } from '@pwskills/rachnaui/Icons';
import { useRouter } from 'next/router';
import { classNames } from '@pwskills/rachnaui/utils';
import { IMultiSelect, IQueryType } from '@/interfaces/courseListing';
import { ChevronDown, ChevronUp } from '@pwskills/rachnaui/Icons';

type propType = {
  filterOption: {
    title?: string;
    slug?: string;
    count?: number;
    id: string;
  }[];
  filterType: string;
  type: string;
  isEndOfObject: boolean;
  isStartOfObject: boolean;
  activeFilter: string | null;
};

export const queryLabel: IQueryType = {
  Program: 'program',
  'Filter by Profession': 'profession',
  Domain: 'domain',
  Category: 'category',
  Instructor: 'instructor',
  'Sub Category': 'subCategory',
  Language: 'language',
  Pricing: 'pricing',
  Level: 'level',
  Tags: 'tags',
};

export const isMultiSelect: IMultiSelect = {
  program: false,
  profession: false,
  domain: false,
  category: true,
  subCategory: true,
  instructor: true,
  language: true,
  pricing: false,
  level: false,
  tags: true,
};

const queryIsID: Record<string, boolean> = {
  'Filter by Program': false,
  'Filter by Profession': false,
  Domain: true,
  Category: true,
  Instructor: true,
  Language: false,
  'Sub Category': true,
  pricing: false,
  // level: true,
  // tags: true,
};

const FilterCategory = (props: propType) => {
  const { filterOption, filterType, type, isEndOfObject, activeFilter, isStartOfObject } = props;
  const [open, setOpen] = useState(true);
  const [viewMore, setViewMore] = useState(false);
  const [, setSelectedRadio] = useState<string | null>(null);
  const router = useRouter();

  const handleFilterClick = (slug: string, optionLabel: string, id: string) => {
    const queryParams = queryLabel[optionLabel];
    const queryValue = router.query[queryParams];
    const isId = queryIsID[optionLabel];

    const value = isId ? id : slug;

    if (type === 'radio') {
      // Set the clicked radio button as selected
      router.query[queryParams] = value;
      setSelectedRadio(value);
    } else if (isMultiSelect[queryParams]) {
      if (Array.isArray(queryValue)) {
        if (queryValue.includes(value)) {
          const index = queryValue.indexOf(value);
          queryValue.splice(index, 1);
        } else {
          router.query[queryParams] = [...queryValue, value];
        }
      } else if (queryValue === value) {
        delete router.query[queryParams];
      } else if (queryValue) {
        router.query[queryParams] = [queryValue, value];
      } else {
        router.query[queryParams] = value;
      }
    } else {
      router.query[queryParams] = value;
    }
    if (!router.query.isFilterChecked) {
      router.query.isFilterChecked = 'true';
    }
    router.push(router);
  };

  const isChecked = (slug?: string, id?: string, title?: string) => {
    const isId = queryIsID[filterType];
    const slugValue = isId ? id : slug;

    const value = router.query[queryLabel[filterType]];

    if (activeFilter && title === activeFilter) {
      return true;
    }
    if (Array.isArray(value)) {
      return value.includes(slugValue as string);
    }
    return slugValue === value;
  };

  if (filterOption?.length) {
    return (
      <div
        className={classNames(
          'flex flex-col !gap-5',
          filterOption?.length ? 'border-b border-stroke-200 pb-[15px]' : '',
          isEndOfObject ? ' border-b border-white medium:!border-stroke-200' : '',
          isStartOfObject ? '' : 'pt-6 large:pt-10'
        )}
      >
        <div
          className="flex justify-between cursor-pointer pointer-events-auto medium:pointer-events-none"
          onClick={() => setOpen(!open)}
          aria-hidden
        >
          <Typography component="subheading" variant="bold" className="text-gray-900">
            {filterType}
          </Typography>
          <div className="medium:hidden">
            {open ? (
              <ChevronUp className="w-5 h-5 cursor-pointer" />
            ) : (
              <ChevronDown className="w-5 h-5 cursor-pointer" />
            )}
          </div>
        </div>

        {open && (
          <div className="flex flex-col medium:flex-row !gap-4 text-gray-850 flex-wrap">
            {!viewMore
              ? filterOption?.slice(0, 5)?.map(({ id, title, slug, count }) =>
                  type === 'radio' && slug ? (
                    <Radio
                      key={slug}
                      checked={isChecked(slug, id, title)}
                      value={slug}
                      label={`${title} ${count && count > 0 ? `(${count})` : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFilterClick(slug, filterType, id);
                      }}
                      labelClass="font-[700] leading-[22px]"
                    />
                  ) : (
                    <Checkbox
                      key={slug}
                      value={slug}
                      checked={isChecked(slug, id, title)}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (slug) handleFilterClick(slug, filterType, id);
                      }}
                    />
                  )
                )
              : filterOption?.map(({ title, slug, count, id }) =>
                  type === 'radio' && slug ? (
                    <Radio
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFilterClick(slug, filterType, id);
                      }}
                      key={slug}
                      checked={isChecked(slug, id, title)}
                      value={slug}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                    />
                  ) : (
                    <Checkbox
                      key={slug}
                      value={slug}
                      checked={isChecked(slug, id, title)}
                      label={`${title} (${count && count})`}
                      labelClass="font-[700] leading-[22px]"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (slug) handleFilterClick(slug, filterType, id);
                      }}
                    />
                  )
                )}
            {filterOption.length > 5 && (
              <Typography
                component="body-small"
                variant="semi-bold"
                className="text-orange-500 cursor-default"
                onClick={() => setViewMore(!viewMore)}
              >
                {viewMore ? 'View less' : 'View more'}
              </Typography>
            )}
          </div>
        )}
      </div>
    );
  }
  return null;
};

export default FilterCategory;
